import {
    ServiceSelectionEnum,
    ServiceSelectionLabelMapping,
} from '../../enums/applications/service-selection-enum';

export class ServiceSelection {
    static getServiceSelections() {
        return [
            ServiceSelectionEnum.SOLO,
            ServiceSelectionEnum.PRO,
            ServiceSelectionEnum.GO,
            ServiceSelectionEnum.EXPRESS,
        ];
    }

    static getServiceSelectionLabels() {
        return Object.values(ServiceSelectionLabelMapping);
    }
}
